/* eslint-disable import/no-mutable-exports */
import { CDN_STATIC_PROD, DOMAIN } from '@bfe/by-dynamic-domain';
import { getOriginalConfigs, getFormattedConfigs, getHreflangHtml } from './seo-hreflang';

/**
 * All site use this key to share language setting
 */
export var BYBIT_LANG_KEY = 'BYBIT_LANG_KEY';

/**
 * All site use this key to share guid. (unique id)
 */
export var BYBIT_GUID_KEY = '_by_l_g_d';

/**
 * All site can sue this key to get the user's theme preference.
 */
export var BYBIT_THEME_KEY = 'BYBIT_THEME_KEY';
export var BYBIT_LOGO_PATH = {
  dark: "".concat(CDN_STATIC_PROD, "/asset/image/logo-white.svg"),
  light: "".concat(CDN_STATIC_PROD, "/asset/image/logo-dark.svg")
};
export var BYBIT_APP_QR_CODE_PATH = "".concat(CDN_STATIC_PROD, "/assets/image/d-").concat(DOMAIN, ".png");
export var ADA_LOCALE_MAP = {
  'en-US': 'en',
  en: 'en',
  'zh-MY': 'zh',
  'ja-JP': 'ja',
  'ko-KR': 'ko',
  'ru-RU': 'ru',
  'vi-VN': 'vi',
  'zh-TW': 'zh-tw',
  'zh-HK': 'zh-tw',
  'en-HK': 'en',
  'es-ES': 'es',
  // 'tr-TR': 'tr',
  'pt-BR': 'pt',
  'fr-FR': 'fr',
  // 'th-TH': 'th',
  'id-ID': 'id',
  'uk-UA': 'uk',
  'kk-KZ': 'kk',
  'ar-SA': 'ar',
  // 'hi-IN': 'hi',
  'fil-PH': 'fil',
  'pt-PT': 'pt',
  'es-MX': 'es',
  'es-AR': 'es',
  'es-419': 'es'
};
export var TRADING_VIEW_LOCALE_MAP = {
  'ro-RO': 'ro',
  'en-US': 'en',
  en: 'en',
  'zh-MY': 'zh',
  'ja-JP': 'ja',
  'ko-KR': 'ko',
  'ru-RU': 'ru',
  'vi-VN': 'vi',
  'zh-TW': 'zh_TW',
  'zh-HK': 'zh_TW',
  'es-ES': 'es',
  'tr-TR': 'tr',
  'pt-BR': 'pt',
  'fr-FR': 'fr',
  // 'th-TH': 'th',
  'id-ID': 'id_ID',
  'uk-UA': 'en',
  'kk-KZ': 'en',
  'ar-SA': 'ar',
  'hi-IN': 'en',
  'fil-PH': 'en',
  'pt-PT': 'pt',
  'es-MX': 'es',
  'es-AR': 'es',
  'es-419': 'es'
};

// 根据 SITE 判断后的： 主站 或 合规站 主站支持的语言, 动态获取的
var BYBIT_LANGUAGES = [{
  label: 'English',
  lang: 'EN',
  value: 'en'
},
// { label: 'English(US)', lang: 'EN', value: 'en-US' }, // en-US 下线
{
  label: 'Bahasa Indonesia',
  lang: 'ID',
  value: 'id-ID'
}, {
  label: 'Español (Internacional)',
  lang: 'ES',
  value: 'es-ES'
},
// { label: 'Español (Latinoamérica)', lang: 'ES', value: 'es-419' }, // 隐藏拉美语 20241225
{
  label: 'Español (México)',
  lang: 'ES',
  value: 'es-MX'
}, {
  label: 'Español (Argentina)',
  lang: 'ES',
  value: 'es-AR'
}, {
  label: 'Filipino',
  lang: 'FIL',
  value: 'fil-PH'
},
// { label: 'Français', lang: 'FR', value: 'fr-FR' },
{
  label: 'қазақша',
  lang: 'KK',
  value: 'kk-KZ'
},
// { label: 'Polski', lang: 'PL', value: 'pl-PL' }, // 隐藏波兰语 20241217
{
  label: 'Português (Brasil)',
  lang: 'BR',
  value: 'pt-BR'
}, {
  label: 'Português (Internacional)',
  lang: 'PT',
  value: 'pt-PT'
},
// { label: 'Românǎ', lang: 'RO', value: 'ro-RO' }, // 隐藏罗马尼亚语 20241217
{
  label: 'Русский',
  lang: 'RU',
  value: 'ru-RU'
}, {
  label: 'Tiếng Việt',
  lang: 'VI',
  value: 'vi-VN'
},
// { label: 'Türkçe', lang: 'TR', value: 'tr-TR' }, // 土耳其语下线 20240905
// { label: 'ไทย', lang: 'TH', value: 'th-TH' }, // 泰语下线 20250427
{
  label: 'Українська',
  lang: 'UK',
  value: 'uk-UA'
}, {
  label: 'العربيه',
  lang: 'AR',
  value: 'ar-SA'
},
// { label: 'हिंदी', lang: 'HI', value: 'hi-IN' }, // 隐藏印度语
{
  label: '日本語',
  lang: 'JA',
  value: 'ja-JP'
},
// { label: '中文简体', lang: 'ZH', value: 'zh-CN' },
{
  label: '简体中文 (马来西亚)',
  lang: 'ZH',
  value: 'zh-MY'
}, {
  label: '繁體中文',
  lang: 'ZH',
  value: 'zh-TW'
}];
export var BYBIT_LANGUAGES_HKG = [{
  label: '繁體中文 (香港)',
  lang: 'ZH',
  value: 'zh-HK'
}, {
  label: 'English(Hong Kong)',
  lang: 'EN',
  value: 'en-HK'
}];
export var BYBIT_LANGUAGES_NLD = [{
  label: 'Dutch',
  lang: 'NL',
  value: 'nl-NL'
}, {
  label: 'English (Netherlands)',
  lang: 'EN',
  value: 'en-NL'
}];
export var BYBIT_LANGUAGES_TUR = [{
  label: 'Türkçe',
  lang: 'TR',
  value: 'tr-TUR'
}, {
  label: 'English(Turkey)',
  lang: 'EN',
  value: 'en-TR'
}];
export var BYBIT_LANGUAGES_KAZ = [{
  label: 'Русский (Казахстан)',
  lang: 'RU',
  value: 'ru-KAZ'
},
// 调整默认语言 20250228
{
  label: 'Қазақша (Қазақстан)',
  lang: 'KK',
  value: 'kk-KAZ'
}, {
  label: 'English (Kazakhstan)',
  lang: 'EN',
  value: 'en-KAZ'
}];
export var BYBIT_LANGUAGES_EU = [{
  label: 'English',
  lang: 'EN',
  value: 'en-EU'
}, {
  label: 'Deutsch',
  lang: 'DE',
  value: 'de-EU'
}, {
  label: 'Español',
  lang: 'ES',
  value: 'es-EU'
}, {
  label: 'Français',
  lang: 'FR',
  value: 'fr-EU'
}, {
  label: 'Italiano',
  lang: 'IT',
  value: 'it-EU'
}, {
  label: 'Nederlands',
  lang: 'NL',
  value: 'nl-EU'
}, {
  label: 'Polski',
  lang: 'PL',
  value: 'pl-EU'
}, {
  label: 'Português',
  lang: 'PT',
  value: 'pt-EU'
}, {
  label: 'Română',
  lang: 'RO',
  value: 'ro-EU'
}];
export var BYBIT_LANGUAGES_GEO = [{
  label: 'ქართული (საქართველო)',
  lang: 'KA',
  value: 'ka-GEO'
}, {
  label: 'Русский (Грузия)',
  lang: 'RU',
  value: 'ru-GEO'
}, {
  label: 'English (Georgia)',
  lang: 'EN',
  value: 'en-GEO'
}];

// 2025-03-18 新增印度尼西亚合规站
export var BYBIT_LANGUAGES_IDN = [{
  label: 'Bahasa Indonesia',
  lang: 'ID',
  value: 'id-IDN'
}, {
  label: 'English (Indonesia)',
  lang: 'EN',
  value: 'en-IDN'
}];

// 2025-06-03 ARE 合规站
export var BYBIT_LANGUAGES_ARE = [{
  label: 'English (UAE)',
  lang: 'EN',
  value: 'en-ARE'
}, {
  label: 'العربيه',
  lang: 'AR',
  value: 'ar-ARE'
}];

// Bybit 主站支持的所有语言
export var BYBIT_LANGUAGES_ALL = [{
  label: 'English',
  lang: 'EN',
  value: 'en'
},
// { label: 'English(US)', lang: 'EN', value: 'en-US' }, // en-US 下线
{
  label: 'Bahasa Indonesia',
  lang: 'ID',
  value: 'id-ID'
}, {
  label: 'Español (Internacional)',
  lang: 'ES',
  value: 'es-ES'
},
// { label: 'Español (Latinoamérica)', lang: 'ES', value: 'es-419' }, // 隐藏拉美语 20241225
{
  label: 'Español (México)',
  lang: 'ES',
  value: 'es-MX'
}, {
  label: 'Español (Argentina)',
  lang: 'ES',
  value: 'es-AR'
}, {
  label: 'Filipino',
  lang: 'FIL',
  value: 'fil-PH'
},
// { label: 'Français', lang: 'FR', value: 'fr-FR' },
{
  label: 'қазақша',
  lang: 'KK',
  value: 'kk-KZ'
}, {
  label: 'Polski',
  lang: 'PL',
  value: 'pl-PL'
}, {
  label: 'Português (Brasil)',
  lang: 'BR',
  value: 'pt-BR'
}, {
  label: 'Português (Internacional)',
  lang: 'PT',
  value: 'pt-PT'
}, {
  label: 'Românǎ',
  lang: 'RO',
  value: 'ro-RO'
}, {
  label: 'Русский',
  lang: 'RU',
  value: 'ru-RU'
}, {
  label: 'Tiếng Việt',
  lang: 'VI',
  value: 'vi-VN'
},
// { label: 'Türkçe', lang: 'TR', value: 'tr-TR' }, // 土耳其语下线 20240905
// { label: 'ไทย', lang: 'TH', value: 'th-TH' },  // 泰语下线 20250427
{
  label: 'Українська',
  lang: 'UK',
  value: 'uk-UA'
}, {
  label: 'العربيه',
  lang: 'AR',
  value: 'ar-SA'
},
// { label: 'हिंदी', lang: 'HI', value: 'hi-IN' }, // 隐藏印度语
{
  label: '日本語',
  lang: 'JA',
  value: 'ja-JP'
},
// { label: '中文简体', lang: 'ZH', value: 'zh-CN' },
{
  label: '简体中文 (马来西亚)',
  lang: 'ZH',
  value: 'zh-MY'
}, {
  label: '繁體中文',
  lang: 'ZH',
  value: 'zh-TW'
}];

// Bybit 主站 + 合规站 支持的所有语言
export var PLATFORM_SUPPORT_LANGUAGES = [].concat(BYBIT_LANGUAGES_ALL, BYBIT_LANGUAGES_HKG, BYBIT_LANGUAGES_TUR, BYBIT_LANGUAGES_KAZ, BYBIT_LANGUAGES_NLD, BYBIT_LANGUAGES_EU, BYBIT_LANGUAGES_GEO, BYBIT_LANGUAGES_IDN, BYBIT_LANGUAGES_ARE);

// 全平台 SITE_ID 和语言映射关系
export var PLATFORM_SUPPORT_LANGUAGES_MAP = {
  BYBIT: BYBIT_LANGUAGES_ALL,
  HKG: BYBIT_LANGUAGES_HKG,
  TUR: BYBIT_LANGUAGES_TUR,
  KAZ: BYBIT_LANGUAGES_KAZ,
  NLD: BYBIT_LANGUAGES_NLD,
  EU: BYBIT_LANGUAGES_EU,
  GEO: BYBIT_LANGUAGES_GEO,
  IDN: BYBIT_LANGUAGES_IDN,
  ARE: BYBIT_LANGUAGES_ARE
};

// site_id 和 域名的映射关系
export var SITE_ID_HOST_MAP = {
  HKG: 'byhkbit.com',
  TUR: 'bybit.tr',
  KAZ: 'bybit.kz',
  NLD: 'bybit.nl',
  GEO: 'bybitgeorgia.ge',
  IDN: 'bybit.id',
  ARE: 'bybit.ae',
  EU: 'bybit.eu'
};
var regulatedSiteHosts = 'BYBIT';
if (typeof window !== 'undefined') {
  var hostname = window.location.hostname;
  regulatedSiteHosts = function () {
    if (hostname === null || hostname === void 0 ? void 0 : hostname.includes(SITE_ID_HOST_MAP.EU)) {
      return 'EU';
    }
    if (hostname === null || hostname === void 0 ? void 0 : hostname.includes(SITE_ID_HOST_MAP.KAZ)) {
      return 'KAZ';
    }
    if (hostname === null || hostname === void 0 ? void 0 : hostname.includes(SITE_ID_HOST_MAP.TUR)) {
      return 'TUR';
    }
    if (hostname === null || hostname === void 0 ? void 0 : hostname.includes(SITE_ID_HOST_MAP.GEO)) {
      return 'GEO';
    }
    if (hostname === null || hostname === void 0 ? void 0 : hostname.includes(SITE_ID_HOST_MAP.IDN)) {
      return 'IDN';
    }
    if (hostname === null || hostname === void 0 ? void 0 : hostname.includes(SITE_ID_HOST_MAP.HKG)) {
      return 'HKG';
    }
    if (hostname === null || hostname === void 0 ? void 0 : hostname.includes(SITE_ID_HOST_MAP.ARE)) {
      return 'ARE';
    }
    if (hostname === null || hostname === void 0 ? void 0 : hostname.includes(SITE_ID_HOST_MAP.NLD)) {
      return 'NLD';
    }

    // 默认是主站
    return 'BYBIT';
  }();
}
if (regulatedSiteHosts === 'HKG') {
  BYBIT_LANGUAGES = BYBIT_LANGUAGES_HKG;
} else if (regulatedSiteHosts === 'NLD') {
  BYBIT_LANGUAGES = BYBIT_LANGUAGES_NLD;
} else if (regulatedSiteHosts === 'TUR') {
  BYBIT_LANGUAGES = BYBIT_LANGUAGES_TUR;
} else if (regulatedSiteHosts === 'KAZ') {
  BYBIT_LANGUAGES = BYBIT_LANGUAGES_KAZ;
} else if (regulatedSiteHosts === 'EU') {
  BYBIT_LANGUAGES = BYBIT_LANGUAGES_EU;
} else if (regulatedSiteHosts === 'GEO') {
  BYBIT_LANGUAGES = BYBIT_LANGUAGES_GEO;
} else if (regulatedSiteHosts === 'IDN') {
  BYBIT_LANGUAGES = BYBIT_LANGUAGES_IDN;
} else if (regulatedSiteHosts === 'ARE') {
  BYBIT_LANGUAGES = BYBIT_LANGUAGES_ARE;
}
export { BYBIT_LANGUAGES, regulatedSiteHosts };

// 判断当前语言是否是 BYBIT_LANGUAGES 支持的语言
// eslint-disable-next-line arrow-body-style
export var getSupportLanguage = function getSupportLanguage(language) {
  return BYBIT_LANGUAGES.find(function (item) {
    return language === item.value;
  }) ? language : 'en';
};

/**
 * 域名和站点ID的映射关系
 * @type {Array}
 * @param {String} hostname
 */
export var domainSiteIdMap = [{
  hostname: SITE_ID_HOST_MAP.NLD,
  siteId: 'NLD'
}, {
  hostname: SITE_ID_HOST_MAP.ARE,
  siteId: 'ARE'
}, {
  hostname: SITE_ID_HOST_MAP.HKG,
  siteId: 'HKG'
}, {
  hostname: SITE_ID_HOST_MAP.TUR,
  siteId: 'TUR'
}, {
  hostname: SITE_ID_HOST_MAP.KAZ,
  siteId: 'KAZ'
}, {
  hostname: SITE_ID_HOST_MAP.GEO,
  siteId: 'GEO'
}, {
  hostname: SITE_ID_HOST_MAP.IDN,
  siteId: 'IDN'
}, {
  hostname: SITE_ID_HOST_MAP.EU,
  siteId: 'EU'
}];

// RTL 语言列表
export var rtlLanguagesList = ['ar-SA', 'ar-ARE'];

// seo
export { getOriginalConfigs, getFormattedConfigs, getHreflangHtml };